import Swiper from "swiper/bundle";
import "./_slider-speakers.scss";

document.addEventListener("DOMContentLoaded", () => {
  const SliderCards = document.querySelectorAll(".slider-speakers");
  SliderCards.forEach((slider) => {
    new Swiper(slider, {
      loop: false,
      spaceBetween: 16,
      slidesPerView: 1,
      keyboard: {
        enabled: true,
      },
      pagination: {
        el: slider.querySelector(".swiper-pagination"),
        clickable: true,
        dynamicBullets: false,
      },
      navigation: {
        nextEl: slider.querySelector(".arrow-next"),
        prevEl: slider.querySelector(".arrow-prev"),
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
        },
        1400: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
  });
});
